import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DataProcessingConsent.module.scss';

const DataProcessingConsent: React.FC = () => {
    const { t } = useTranslation();

    const consentText = t('ConsentPage.consentText');
    const renderedConsentText = consentText.split('\\n').map((line, index, array) => (
        <React.Fragment key={index}>
            {line}
            {index < array.length - 1 && <br />}
        </React.Fragment>
    ));

    return (
        <div className={styles.container}>
            <h1 className={styles.pageTitle}>
                {t('ConsentPage.consentToTheProcessingOfPersonalData')}
            </h1>

            <div className={styles.contentContainer}>
                <p className={styles.consentParagraph}>
                    {renderedConsentText}
                </p>
            </div>
        </div>
    );
};

export default DataProcessingConsent;